<template>
  <div class="start">
    <Header />
    <template v-if="content">
      <Hero
        :heading="content.heading"
        :subheading="content.subHeading"
      />
      <InctContent :content="content" />
    </template>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Hero from '@/components/Hero.vue'
import Footer from '@/components/Footer.vue'
import InctContent from "@/components/content/InctContent.vue";
import axios from "axios";

export default {
  name: 'SportView',
  components: {
    InctContent,
    Header,
    Hero,
    Footer
  },
  data() {
    return {
      content: undefined
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getContent();
  },
  methods: {
    getContent() {
      const cId = this.$t('general.settings.currentLanguageCode') === 'de' ?  63 : 67;
      //const url = liveURL
      const url = "https://derdachstein.myincert.com"
        + `/api/frontend/contentElements/${cId}?language=${this.$t('general.settings.currentLanguageCode')}`;
      axios.get(url, {}).then(function (response) {
        this.content = response.data;
      }.bind(this))
        .catch(function (error) {
          console.log(error);
        });
    }
  }
}
</script>
